module.exports = __webpack_public_path__ + "img/bime-day.097c3fd.png";